import { Injectable } from '@angular/core';
import { ApiClientService } from '../../core/services/api-client.service';
import { EnseigneConfig } from './enseigne.model';

@Injectable({
  providedIn: 'root',
})
export class EnseigneConfigService extends ApiClientService {
  /**
   * Retrieves all brands
   * GET /config/enseigne
   */
  getAllEnseignes() {
    return this.get<EnseigneConfig[]>('/config/enseigne');
  }

  /**
   * Updates the configuration of a brand
   * PUT /config/enseigne
   */
  updateEnseigneConfig(config: EnseigneConfig[]) {
    return this.put<EnseigneConfig[]>('/config/enseigne', config);
  }

  /**
   * Deletes a brand configuration
   * DELETE /config/enseigne/:codeOrg
   */
  deleteEnseigneConfig(codeOrg: string) {
    return this.delete(`/config/enseigne/${codeOrg}`);
  }
}
